import React, { FC, useEffect, useState } from "react";

import { useDownloadFilePreview } from "@api";
import { useUserStore } from "@store/user";

interface DownloadPreview {
  path: string;
  name: string;
}

const DownloadPreview: FC<DownloadPreview> = ({ path, name }) => {
  const [objectUrl, setObjectUrl] = useState<string | null>(null);
  const { user } = useUserStore();
  const { downloadFilePreview, downloadFileEnabled } = useDownloadFilePreview(user);

  const handleFileDownload = async (): Promise<void> => {
    const blob = await downloadFilePreview({ path, name });
    const _objectUrl = URL.createObjectURL(blob);

    setObjectUrl(_objectUrl);
  };

  useEffect(() => {
    if (path) {
      handleFileDownload();
    }
  }, [path]);

  return (
    downloadFileEnabled &&
    (objectUrl ? (
      <img
        src={objectUrl}
        alt={name}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    ) : null)
  );
};

export default DownloadPreview;
